<template>
  <div v-if="weAreInRenewalProposalPage" class="button-for-decision-making">
    <DecisionDialog v-model="dialog" />

    <RBtn
      :disable="!dataForBatchDecisionMaking || !hasRowSelection || noAcceptAndCancel"
      size="small"
      @click="dialog = true"
    >
      <LmTooltip max-width="280px" anchor="top middle" self="bottom middle">
        <span class="text-body-1">
          Accepting or canceling here is the same as making a decision through the workflow or on the subscription page.
          The subscriptions will enter the “Place orders” task.
        </span>
      </LmTooltip>
      Accept<template v-if="toAcceptCount !== null && !noAcceptAndCancel">({{ toAcceptCount }})</template>
      / Cancel Subscriptions
      <span v-if="toCancelCount !== null && !noAcceptAndCancel"> ({{ toCancelCount }}) </span>
    </RBtn>
  </div>
</template>

<script>
import DecisionDialog from './DecisionDialog'

export default {
  components: {
    DecisionDialog
  },

  data: () => ({
    dialog: false,
    isMounted: false
  }),

  computed: {
    weAreInRenewalProposalPage() {
      return this.$route.path.includes('renewal-proposal')
    },

    dataForBatchDecisionMaking() {
      if (!this.weAreInRenewalProposalPage || !this.isMounted) return null
      return this.$store.state['renewal-proposal'].dataForBatchDecisionMaking
    },

    hasRowSelection() {
      if (!this.dataForBatchDecisionMaking) return false
      const selectAll = this.$store.state['renewal-proposal'].selectAll
      const rowsSelected = this.$store.state['renewal-proposal'].rowsSelected

      if (!rowsSelected.length && !selectAll) return false
      return true
    },

    toAcceptCount() {
      if (!this.dataForBatchDecisionMaking || !this.hasRowSelection) return null
      return this.dataForBatchDecisionMaking.find(d => d.name === 'to accept')?.subscription_period_ids?.length ?? 0
    },

    toCancelCount() {
      if (!this.dataForBatchDecisionMaking || !this.hasRowSelection) return null
      return this.dataForBatchDecisionMaking.find(d => d.name === 'to cancel')?.subscription_period_ids?.length ?? 0
    },

    noAcceptAndCancel() {
      return !this.toAcceptCount && !this.toCancelCount
    }
  },

  watch: {
    hasRowSelection(newVal) {
      // clear data when there is no row selection
      if (!newVal && this.$store.hasModule('renewal-proposal')) {
        this.$store.commit('renewal-proposal/setDataForBatchDecisionMaking', null)
      }
    }
  },

  mounted() {
    this.isMounted = true
  }
}
</script>
